import { ProductsEndpoint as ProductsEndpointInterface } from '@apiClient/interfaces/endpoints/Products.endpoint';
import { buildSearchParams } from '@/utils/handlers/urlHandler';
import { KyInstance } from "ky/distribution/types/ky";
import { KyResponse } from 'ky';
import ApiResponseDto from '@/projectRoot/api-client/interfaces/response/ApiResponse.dto';
import ProductDto from '@/projectRoot/api-client/interfaces/models/products/Product.dto';
import ProductsSearchDto from '@/projectRoot/api-client/interfaces/request/products/ProductsSearch.dto';
import MetaFilter from '@/projectRoot/api-client/interfaces/response/products/MetaFilter.dto';
import FilterStatsDto from '@/projectRoot/api-client/interfaces/response/products/FilterStats.dto';

export class ProductsEndpoint implements ProductsEndpointInterface {
   
    private _httpClient: KyInstance;
    private cache: RequestCache;

    public constructor(client: KyInstance, cache: RequestCache = process.env.NEXT_PUBLIC_ENVIRONMENT == 'staging' ? "no-store" : "force-cache") {
        this._httpClient = client;
        this.cache = cache;
    }

    get httpClient(): KyInstance {
        if (!this._httpClient) {
            throw new Error('Ky http client is not initialized');
        }
        return this._httpClient;
    }

    set httpClient(kyInstance: KyInstance) {
        this._httpClient = kyInstance;
    }

    /**
    * Return found products, always ordered by parent_breadcrumbs and order field
    * /api/products
    */
    async search(params?: ProductsSearchDto): Promise<ApiResponseDto<ProductDto[], MetaFilter<FilterStatsDto>>> {
        return this._httpClient
            .get(`products`, { searchParams: params ? buildSearchParams(params) : {}, cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    /**
    * Return found product, always ordered by parent_breadcrumbs and order field
    * /api/products/{id}
    */
    async single(id: string): Promise<ApiResponseDto<ProductDto, undefined>> {
        return this._httpClient
            .get(`products/${id}`, { cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    /**
    * Return found product, always ordered by parent_breadcrumbs and order field
    * /api/products/draft/{id}
    */

    async draft(id: string): Promise<ApiResponseDto<ProductDto, undefined>> {
        return this._httpClient
            .get(`products/draft/${id}`, { cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText);
                }
                const response: ApiResponseDto<ProductDto, undefined> = await kyResponse.json();
                return response;
            });
    }
}

export default ProductsEndpoint;